angular.module('tf.models')


    .factory("Control",[function(){

        var control = function Control(data) {
            this.loadData(data);
        };


        control.prototype = {

            loadData: function (data) {
                angular.extend(this, data);

                if(this.ui.type === 'browse'){
                    this.size = this.size !== undefined? this.size : 2;
                    this.crop = this.crop || {x0 : 0, y0 : 0, x1 : 1, y1 : 1};
                    this.isCrop = this.isCrop || false;
                }
                limitValue(this);
            }

        };


        function limitValue(control){
            if(control.value && control.limit){
                try{
                    control.value = control.value.substr(0, parseInt(control.limit));
                }catch(err){}

            }
        }

        return control;

    }]);
